import uuid from 'uuid/v4';
import { getQueryStringValue } from './utils/getQueryStringValue';
import { storeRAID } from './components/storeRAID';
import { getRAID } from './components/getRAID';
import { setRAIDInput } from './components/setRAIDInput';

const RAID_STORAGE_KEY = 'ramseyAnonymousId';
const RAID_QUERY_PARAM = 'raid';

/**
 * @deprecated use [storeRAID method]{@link storeRAID} instead
 */
const setRAID = () => {
  const queryStringValue = getQueryStringValue(RAID_QUERY_PARAM);

  if (queryStringValue !== '') {
    window.localStorage.setItem(RAID_STORAGE_KEY, queryStringValue);
    return;
  }

  if (window.localStorage.getItem(RAID_STORAGE_KEY)) {
    return;
  }

  window.localStorage.setItem(RAID_STORAGE_KEY, uuid());
};

const pushRAID = () => {
  window.gtmDataLayer = window.gtmDataLayer || [];
  window.gtmDataLayer.push({
    ramseyAnonymousId: getRAID()
  });
};

export {
  RAID_STORAGE_KEY,
  RAID_QUERY_PARAM,
  setRAID,
  storeRAID,
  getRAID,
  setRAIDInput,
  pushRAID
};
